import React, { useEffect, useState } from "react";

import { Link } from "react-router-dom";

import Layout from "../../components/Layout";

import { apiCRMv3 } from "../../services/api";

import Swal from "sweetalert2";

export const SuperComboCampaignList = (props) => {
	const [superComboCampaigns, setSuperComboCampigns] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [loaded, setLoaded] = useState(true);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);

	useEffect(() => {
		loadSuperComboCampaigns();
	}, []);

	const loadSuperComboCampaigns = async (pageNumber = 1) => {
		setLoaded(false);
		const returnSuperComboCampaigns = await apiCRMv3.get(
			`/super-combo-campaign/get-paginated?page=${pageNumber}`,
		);
		console.log(returnSuperComboCampaigns.data.data);
		if (returnSuperComboCampaigns.status === 500) {
			Swal.fire({
				type: "error",
				title: "Erro!",
				text: "Tivemos um problema ao buscar as campanhas do super combo. Contate o suporte!",
			}).then(() => this.props.history.push("/"));
			return;
		}

		setSuperComboCampigns(
			returnSuperComboCampaigns.data.data.superComboCampaigns,
		);
		setTotalPages(
			Math.trunc(
				returnSuperComboCampaigns.data.data.superComboCampaignsCount /
					10,
			),
		);
		setPage(pageNumber);
		setLoaded(true);
	};

	const handleDeleteButton = async (currentOffer) => {
		setLoaded(false);
		Swal.fire({
			title: `Tem certeza que deseja excluir a campanha?`,
			text: "Ao excluir esse registro, a campanha será apagada sem retorno! CUIDADO!!!",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText: "Sim, quero excluir!",
			cancelButtonText: "Cancelar",
		}).then(async function (result) {
			if (result.value) {
				console.log(currentOffer);
				const deletedSuperComboCampaign = await apiCRMv3.delete(
					`/super-combo-campaign/${currentOffer.id}`,
				);
				if (deletedSuperComboCampaign.status === 204) {
					loadSuperComboCampaigns();
					setSearchTerm("");
					Swal.fire(
						"Excluído!",
						"A campanha foi excluída com sucesso de todas as filiais!",
						"success",
					);
					setLoaded(true);
				} else {
					Swal.fire(
						"Oops...",
						"Não foi possível excluir a campanha agora. Por favor contate o suporte!",
						"error",
					).then(() => {
						setLoaded(true);
					});
				}
			} else {
				setLoaded(true);
				setSearchTerm("");
			}
		});
	};

	return (
		<Layout
			menuActive="registers"
			pageTitle="Super Combo Campanhas"
			enableSearchBar={false}
			searchTerm={searchTerm}
			searchOnChange={(e) => {
				const { value } = e.target;
				setSearchTerm(value);
			}}
			handleSearch={() => {}}
		>
			<div className="row">
				<div className="col-xs-12">
					<div className="card">
						<div className="card-header">
							<div className="card-title">
								Super Combo - Lista de Campanhas
							</div>
							<ul className="card-action">
								<li>
									<Link
										to="/super-combo-campanhas/nova"
										className="btn btn-sm btn-success"
									>
										Nova <i className="fa fa-plus"></i>
									</Link>
								</li>
							</ul>
						</div>
						<div
							className={`card-body table-responsive ${
								loaded ? "" : "__loading"
							}`}
						>
							<div className="loader-container text-center">
								<div className="icon">
									<div className="sk-wave">
										<div className="sk-rect sk-rect1"></div>
										<div className="sk-rect sk-rect2"></div>
										<div className="sk-rect sk-rect3"></div>
										<div className="sk-rect sk-rect4"></div>
										<div className="sk-rect sk-rect5"></div>
									</div>
								</div>
								<div className="title">Carregando</div>
							</div>

							<div className="row">
								<div className="col-xs-12">
									<table className="table table-striped table-bordered table-hover">
										<thead>
											<tr>
												<th>Nome</th>
												<th>Opções</th>
											</tr>
										</thead>
										<tbody>
											{superComboCampaigns
												.filter((item) =>
													String(item.name)
														.toLowerCase()
														.includes(
															searchTerm.toLowerCase(),
														),
												)
												.map(
													(
														superComboCampaign,
														indexSuperComboCampaign,
													) => {
														return (
															<tr
																key={
																	indexSuperComboCampaign
																}
															>
																<td
																	style={{
																		width: "80%",
																	}}
																>
																	{
																		superComboCampaign.name
																	}
																</td>
																<td>
																	<div className="col-xs-12">
																		<div className="col-xs-12">
																			<button
																				className="btn btn-xs btn-danger"
																				onClick={() => {
																					handleDeleteButton(
																						superComboCampaign,
																					);
																				}}
																				style={{
																					width: "100%",
																				}}
																			>
																				Excluir{" "}
																				<div className="icon fa fa-trash-o"></div>
																			</button>
																		</div>
																	</div>
																</td>
															</tr>
														);
													},
												)}
										</tbody>
									</table>
								</div>
							</div>
							{totalPages !== 0 ? (
								<div className="row">
									<div className="col-xs-12">
										<ul className="pagination">
											{Array(totalPages)
												.fill()
												.map((_, pageItem) => (
													<li
														className={
															pageItem + 1 ===
															page
																? "active"
																: ""
														}
													>
														<a
															href="#"
															onClick={(e) => {
																e.preventDefault();
																loadSuperComboCampaigns(
																	pageItem +
																		1,
																);
															}}
														>
															{page + 1}
														</a>
													</li>
												))}
										</ul>
									</div>
								</div>
							) : null}
						</div>
					</div>
				</div>
			</div>
		</Layout>
	);
};
